/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PlanDetailResponse } from '../model';
// @ts-ignore
import { PlanItemResponse } from '../model';
// @ts-ignore
import { PlanResponse } from '../model';
/**
 * PlanControllerApi - axios parameter creator
 * @export
 */
export const PlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanDetail: async (partnerSlug: string, planSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerSlug' is not null or undefined
            assertParamExists('getPlanDetail', 'partnerSlug', partnerSlug)
            // verify required parameter 'planSlug' is not null or undefined
            assertParamExists('getPlanDetail', 'planSlug', planSlug)
            const localVarPath = `/partners/{partnerSlug}/plans/{planSlug}`
                .replace(`{${"partnerSlug"}}`, encodeURIComponent(String(partnerSlug)))
                .replace(`{${"planSlug"}}`, encodeURIComponent(String(planSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPlans: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFeaturedPlans: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/featured-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlans: async (partnerSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerSlug' is not null or undefined
            assertParamExists('listPlans', 'partnerSlug', partnerSlug)
            const localVarPath = `/partners/{partnerSlug}/plans`
                .replace(`{${"partnerSlug"}}`, encodeURIComponent(String(partnerSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuggestedPlans: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/plans/suggested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanControllerApi - functional programming interface
 * @export
 */
export const PlanControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanDetail(partnerSlug: string, planSlug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanDetail(partnerSlug, planSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllPlans(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllPlans(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFeaturedPlans(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFeaturedPlans(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} partnerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlans(partnerSlug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlans(partnerSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSuggestedPlans(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSuggestedPlans(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlanControllerApi - factory interface
 * @export
 */
export const PlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanDetail(partnerSlug: string, planSlug: string, options?: any): AxiosPromise<PlanDetailResponse> {
            return localVarFp.getPlanDetail(partnerSlug, planSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPlans(options?: any): AxiosPromise<Array<PlanItemResponse>> {
            return localVarFp.listAllPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFeaturedPlans(options?: any): AxiosPromise<Array<PlanItemResponse>> {
            return localVarFp.listFeaturedPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} partnerSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlans(partnerSlug: string, options?: any): AxiosPromise<Array<PlanResponse>> {
            return localVarFp.listPlans(partnerSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuggestedPlans(options?: any): AxiosPromise<Array<PlanItemResponse>> {
            return localVarFp.listSuggestedPlans(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanControllerApi - object-oriented interface
 * @export
 * @class PlanControllerApi
 * @extends {BaseAPI}
 */
export class PlanControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} partnerSlug 
     * @param {string} planSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanControllerApi
     */
    public getPlanDetail(partnerSlug: string, planSlug: string, options?: AxiosRequestConfig) {
        return PlanControllerApiFp(this.configuration).getPlanDetail(partnerSlug, planSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanControllerApi
     */
    public listAllPlans(options?: AxiosRequestConfig) {
        return PlanControllerApiFp(this.configuration).listAllPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanControllerApi
     */
    public listFeaturedPlans(options?: AxiosRequestConfig) {
        return PlanControllerApiFp(this.configuration).listFeaturedPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} partnerSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanControllerApi
     */
    public listPlans(partnerSlug: string, options?: AxiosRequestConfig) {
        return PlanControllerApiFp(this.configuration).listPlans(partnerSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanControllerApi
     */
    public listSuggestedPlans(options?: AxiosRequestConfig) {
        return PlanControllerApiFp(this.configuration).listSuggestedPlans(options).then((request) => request(this.axios, this.basePath));
    }
}

